import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initSentry } from "@livingsyncs/ui";
import "./lib/cognito"; // Initialize Amplify before any auth calls

// Initialize Sentry before rendering
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
